import { Dispatch, SetStateAction, useState } from 'react';
import { Modal, Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedReason: string;
  setSelectedReason: Dispatch<SetStateAction<string>>;
}

export default function CancelEventModal({
  open,
  onClose,
  setOpen,
  selectedReason,
  setSelectedReason
}: RejectReasonModalProps) {
  const [localReason, setLocalReason] = useState(selectedReason || 'value1');
  const navigate = useNavigate();

  const handleSubmit = () => {
    setSelectedReason(localReason); // Update parent only on submit

    if (localReason === 'value1') {
      setOpen(false);
      navigate('/user-table');
    } else {
      setOpen(false);
    }
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalReason(e.target.value); // Local state only
  };

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Are you sure you want to Cancel?</h2>
                 <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
          </div>
          <form className="form">
            <RadioGroup
              value={localReason}
              onChange={handleRadioChange}
            >
              <FormControlLabel value="value1" control={<Radio />} label="Refund" />
              <FormControlLabel value="value2" control={<Radio />} label="Compensation" />
            </RadioGroup>

            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
